import { useRef } from 'react';
import { Tooltip, PlacesType } from 'react-tooltip';
import cn from 'classnames';
// Ui
import MillionsIcon, { IconNames } from 'ui3/MillionsIcon/MillionsIcon';
// Styles
import styles from './InfoTooltip.module.scss';
import 'react-tooltip/dist/react-tooltip.css';

type InfoTooltipProps = {
  text: string | string[];
  title?: string;
  iconName?: IconNames;
  iconSize?: number;
  place?: PlacesType;
  className?: string;
  iconClassName?: string;
};

const InfoTooltip = ({
  text,
  title,
  iconName = 'infoCircle',
  iconSize = 20,
  place = 'bottom',
  className,
  iconClassName,
}: InfoTooltipProps) => {
  const tooltipId = useRef(
    `info-tooltip-${Math.random().toString(36).slice(2, 9)}`
  ).current;

  return (
    <div className={cn(styles.root, className)}>
      <MillionsIcon
        id={tooltipId}
        name={iconName}
        size={iconSize}
        className={cn(styles.icon, iconClassName)}
      />
      <Tooltip
        anchorId={tooltipId}
        place={place}
        clickable
        className={styles.tooltip}
      >
        {title && <p className={styles.tooltipTitle}>{title}</p>}
        {(Array.isArray(text) ? text : [text]).map((paragraph) => (
          <p key={paragraph} className={styles.tooltipText}>
            {paragraph}
          </p>
        ))}
      </Tooltip>
    </div>
  );
};

export default InfoTooltip;
